//disruptr
//So far, this plugin simply opens a panelizr panel after a set amount of time.
//We use a hidden panelizr-link and call .click() on it after the delay
//We could consider creating a way to open panelizr programattically
//Currently relying on panelizr's context "DESKTOP" to prevent it from firing on mobile -- we may want to expand functionality here to have some other disruptn on mobile
//We are setting the height in sitecore, this is because Liveball uses iframes and we won't know their height in advance

; define('core/ef_plugins/disruptr',["jquery", "core/global/helpers", "underscore", "libs/jquery.cookie"], function(jQuery, helpers) {
    (function($, window, document, undefined) {
        var pluginName = 'disruptr',
            defaults = {
                seconds: 8, //delay -- set in cookies for hoverbox
                startTimerOnInit: true, // bool - Should the timer start counting when disruptr is initialized? If not, you'll need to start the timer manually.
                panelizrLink: "", //hidden panelizr link -- call click() on this after delay to open disruptr
                sessionCookieName: "disruptedThisSession", // Name of the cookie used to store whether the user has seen the disruptr this session.
                longTermCookieName: "disruptedLongTerm", // Name of the cookie used to store the number of times the user has seen the disruptr. Set to "" to disable.
                countKeyName: "Count",
                disableKeyName: "Disable",
                maxViewCount: 2, // Number of times to show the hoverbox. If longTermCookieName is "", maxViewCount is ignored.
                openCallback: function () { },
                isMobile: false, // bool - Only changed in the Hoverbox.Mobile rendering
                showDisruptr: false // is userdefined
            };

        // The actual plugin constructor
        // ReSharper disable once InconsistentNaming
        function Disruptr(element, options) {
            // grab the element the plugin was called on
            this.element = element;

            // also save the element as a jquery object
            this.$element = $(element);

            // get per-element inline configuration settings
            this.metadata = this.$element.data('disruptr-options');

            // merge all the configs
            this.options = $.extend({}, defaults, options, this.metadata);

          

            // save the defaults
            this._defaults = defaults;
            this._name = pluginName;

            // Convert "true" or "false" strings in metadata to booleans
            this.options.startTimerOnInit = helpers.toBool(this.options.startTimerOnInit);

            // set open flag
            this.isOpen = false;

            // Number of times disruptr has been viewed. Will be updated in init.
            this.viewCount = 0;

            // Has User never logined or submitted before?
            this.disable = true;

            // Has the popup opened? If the popup has been opened, this value will be true even after the user closes the popup.
            this.hasOpened = false;

            // call init function 
            this.init();
        }

        // Define this sucker
        Disruptr.prototype = {
            init: function() {
                var plugin = this;

                // check that the callback passed in is really a function & handle namespaced functions               
                if (plugin.options.openCallback && !(typeof plugin.options.openCallback === "function")) {
                    plugin.options.openCallback = helpers.getFuncFromString(plugin.options.openCallback);
                }

                if (plugin.options.longTermCookieName) {
                    plugin.viewCount = plugin.readCookie(plugin.options.longTermCookieName, plugin.options.countKeyName);
                    plugin.disable = plugin.readCookie(plugin.options.longTermCookieName, plugin.options.disableKeyName);
                }
                if ((plugin.viewCount >= plugin.options.maxViewCount) || plugin.hasSubmittedFormOrLogin() || plugin.facebookFormLink("hb") === "0") {
                    // User should not see the disruptr. Don't initialize the plugin.
                    plugin.destroy();
                    return;
                }
                // Create a new instance of the timer, and pass it a reference to the plugin.
                // There might be a more elegant way to make the timer aware of the plugin.
                
                this.timer = new Timer(plugin);
                if (plugin.options.startTimerOnInit) {
                    plugin.timer.start();
                }
            },

            hasSubmittedFormOrLogin: function() {
                var plugin = this;
                // If User has submitted or login, disable disruptr
                // Read cookie again in case that user submitted form but page was not reloaded
                plugin.disable = plugin.readCookie(plugin.options.longTermCookieName, plugin.options.disableKeyName);
                return (plugin.disable == true);
            },

            facebookFormLink: function (fbVar) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == fbVar){return pair[1];}
                }
                return(false);
            },

            open: function () {
                
                // re-reference the plugin to avoid this conflicts
                var plugin = this;
                // click the panelizr link to open it
                if (this.showMobile()) {
                        this.mobilizr = new Mobilizr(plugin);
                        plugin.mobilizr.init();
                    } else {
                        if (plugin.options.panelizrLink) {
                            $(plugin.options.panelizrLink).trigger("click");
                        }
                }

                plugin.options.openCallback();

                //set cookie so only one disruption occurs per session
                plugin.setCookies();
                plugin.hasOpened = true;
            },

            showMobile: function () {  
                return this.options.showDisruptr;
            },
            readCookie: function(cookieName, cookieKey) {
                var plugin = this,
                    cookieVal,
                    cookieObj,
                    cookieString;

                if (!cookieName || typeof cookieName !== "string" || !cookieKey) {
                    return false;
                }
                $.cookie.raw = true;
                cookieString = $.cookie(cookieName);
                $.cookie.raw = false;
                if (cookieString) {
                    // Get everything after the = sign.
                    cookieObj = plugin.deparamCookieToObj(cookieString);
                    cookieVal = cookieObj[cookieKey];
                }
                // In case cookieVal does not exist
                if (isNaN(cookieVal)) {
                    if (cookieVal === "true")  return true;
                    switch (cookieKey) {
                    case this.options.countKeyName:
                        cookieVal = 0;
                        break;
                    case this.options.disableKeyName:
                        cookieVal = false;
                        break;
                    default:
                        cookieVal = false;
                    }
                }
                return cookieVal;
            },

            deparamCookieToObj: function(cookieString) {
                var queryString = {};
                var vars = cookieString.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    pair[0] = decodeURIComponent(pair[0]);
                    pair[1] = decodeURIComponent(pair[1]);
                    // If first entry with this name
                    if (typeof queryString[pair[0]] === "undefined") {
                        queryString[pair[0]] = pair[1];
                        // If second entry with this name
                    } else if (typeof queryString[pair[0]] === "string") {
                        var arr = [queryString[pair[0]], pair[1]];
                        queryString[pair[0]] = arr;
                        // If third or later entry with this name
                    } else {
                        queryString[pair[0]].push(pair[1]);
                    }
                }
                return queryString;
            },

            setCookies: function() {
                var domain = document.domain.toString(),
                    domainPieces = domain.split('.'),
                    rootDomain = "." + domainPieces[domainPieces.length - 2] + "." + domainPieces[domainPieces.length - 1],
                    plugin = this;
                // Get the root domain, tge part of the domain name before second-to-last dot. Typically ".eftours.com." That way, the cookie works across subdomains.
                // Given www.eftours.com, eftours.com, landing.eftours.com, or blah.foo.bar.eftours.com, the root domain should be .eftours.com.
                if (plugin.viewCount < plugin.options.maxViewCount) {
                    // User should see the form. We'll increment the count and update the cookie.
                    plugin.viewCount++;
                }

                // For compatibility with Liveball, we'll temporarily set raw = true.
                // This prevents jQuery cookie from URI encoding the cookie value.
                $.cookie.raw = true;
                $.cookie(plugin.options.sessionCookieName, 'true', {
                    path: '/',
                    domain: rootDomain
                });
                // Set Count and Disable value to cookie
                if (plugin.options.longTermCookieName !== "") {
                    var cookieString = "Count=" + plugin.viewCount + "&Disable=" + plugin.disable;
                    $.cookie(plugin.options.longTermCookieName, cookieString, {
                        expires: 180,
                        path: '/',
                        domain: rootDomain
                    });
                }
                $.cookie.raw = false;
            },

            destroy: function() {
                var plugin = this;
                if (typeof plugin.timer === "object" && typeof plugin.timer.stop == "function") {
                    plugin.timer.stop();
                }
                plugin.$element.removeData('plugin_' + pluginName);
            }
        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function(options) {
            return this.each(function() {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Disruptr(this, options));
                }
            });
        }

        // Mini-plugin for timer. Timer is only accessible within disruptr.js.
        // ReSharper disable once InconsistentNaming
        function Timer(parent) {
            this.plugin = parent;
        }

        Timer.prototype = {
            timeout: null,
            running: false, // Is the timer currently running?
            wasStarted: false, // Was the timer started at some point? It may since have been stopped.
            plugin: {},
            start: function (unpauseOnly) {
                var self = this;
                var plugin = this.plugin;
                if (self.running) {
                    // If the timer is already running, don't create a new timeout. Doing so would prevent stop() from working.
                    return false;
                }
                if (unpauseOnly === true && !self.wasStarted) {
                    return false;
                }
                self.timeout = window.setTimeout(function () {
                    if (!plugin.hasOpened && !plugin.hasSubmittedFormOrLogin()) {
                        plugin.open();
                        self.running = false;
                    }
                }, plugin.options.seconds * 1000);
                self.running = true;
                self.wasStarted = true;
                return true;
            },
            stop: function () {
                var self = this;
                if (!self.running) {
                    return false;
                }
                window.clearTimeout(self.timeout);
                self.running = false;
                return true;
            }
        }


        // Mini-plugin for Mobilizr. Mobilizr is only accessible within disruptr.js.
        // ReSharper disable once InconsistentNaming
        function Mobilizr(parent) {
            this.plugin = parent;
        }

        Mobilizr.prototype = {
            init: function () {
                var self = this,
                    plugin = this.plugin,
                    $mobilizr = $(".bottom-slide-bar"),
                    $launchPanelizr = $(".bottom-slide-bar #opt-in"),
                    $cancel = $(".bottom-slide-bar #opt-out");
                var height = $mobilizr.outerHeight();
                $mobilizr.css({ bottom: "-" + height + "px", display: "block" }).animate({ bottom: "0" });
                $launchPanelizr.on("click", function () {
                    if (plugin.options.panelizrLink) {
                        $(plugin.options.panelizrLink).trigger("click");
                        $mobilizr.remove();
                    }
                })
                $cancel.on("click", function () {
                    $mobilizr.remove();
                })
            }
        }


    })(jQuery, window, document);
});
